import React from 'react';
import { styled } from 'styled-components';
import { useIntl } from 'react-intl';
import { ReadMore, Typography, tk } from '@sunwebgroup/ui-components';
import { useQuery } from '@tanstack/react-query';
import { translationAPIClient } from '@/scopes/products/user-reviews/infrastructure/api/translations';

const TextIsTranslating = styled.div`
  ${Typography} {
    color: ${tk('color_semantic_text_subdued')};
  }
`;

const ErrorMessage = styled(Typography)`
  color: ${tk('color_semantic_text_error')};
`;

export function TranslatedText({ children }: { children: string }) {
  const intl = useIntl();
  const {
    isLoading,
    data: translatedText,
    error,
  } = useQuery({
    queryKey: ['translated-reviews', children],
    queryFn: () => translationAPIClient.translate(children),
  });

  if (isLoading)
    return (
      <TextIsTranslating>
        <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
          {children}
        </ReadMore>
      </TextIsTranslating>
    );

  if (error)
    return (
      <>
        <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
          {children ?? ''}
        </ReadMore>
        <ErrorMessage>{intl.formatMessage({ id: 'reviews_translation_error' })}</ErrorMessage>
      </>
    );

  return (
    <ReadMore charactersShown={255} readMoreText={intl.formatMessage({ id: 'reviews_read_more_label' })}>
      {translatedText ?? ''}
    </ReadMore>
  );
}
